module.exports = __webpack_public_path__ + "images/ac1.png";